import { FC } from 'react';
import styles from './styles.module.scss';
import { useStopScroll } from '@/common/hooks/useStopScroll';
import { Spinner } from '@/shared/ui/Spinner';

interface Props {
  isLoading: boolean;
}

export const LoaderPage: FC<Props> = ({ isLoading }) => {
  useStopScroll(isLoading);
  if (!isLoading) return null;
  return (
    <div className={styles.pageLoader}>
      <Spinner />
    </div>
  );
};
